import { createSlice } from '@reduxjs/toolkit';
import api from '../utils/httpClient';
import { createAsyncThunk } from '@reduxjs/toolkit';


export const getBulletinsThunk = createAsyncThunk(
	'patientBulletin/getBulletinsThunk',
	async (patientId:string) => {
	  console.log('getBulletinsThunk params');

	  const response = await api.get(
	  `patient/${patientId}/bulletin_board`,
	  {
		timeout: 30000,
	  });
	  console.log('getBulletinsThunk response', response.data);
	  return response.data;
	}
);

export const createBulletinThunk = createAsyncThunk(
    'patientBulletin/createBulletinThunk',
    async (params: { patientId: string; name: string }) => {
      const { patientId, name } = params;
      const response = await api.post(`/bulletin_board`, {
        patientId, name
      });
      console.log('createBulletinThunk response', response.data);
	  return response.data;
    }
);
  
export const updateBulletinThunk = createAsyncThunk(
  'patientBulletin/updateBulletinThunk',
  async (params: { bulletinId: string; content: string}) => {
    const { bulletinId, content } = params;
    const response = await api.put(`/bulletin_board/${bulletinId}`, {
        content
    });
    console.log('updateBulletinThunk response', response.data);
	return response.data;
    // return {
    //     bulletinBoardId,
    // };
  }
);

export const deleteBulletinThunk = createAsyncThunk(
  'patientBulletin/deleteBulletinThunk',
  async (params: { bulletinId: string}) => {
    const { bulletinId } = params;
    const response = await api.delete(`/bulletin_board/${bulletinId}`, {});
    console.log('deleteBulletinThunk response', response.data);
	return response.data;
    // return {
    //   userId,
    // };
  }
);

const initialState: {
    status: string;
    error: string;
    data: any;
} = {
    status: '',
    error: '',
    data: {},
};

const patientBulletinSlice = createSlice({
    name: 'patientBulletin',
    initialState: initialState,
    reducers: {
        patientBulletinSliceClean(state, action) {
          console.log('patientBulletinSliceClean', action);
          state.data.getLoading = false;
          state.data.getComplete = false;
          state.data.postLoading = false;
          state.data.postComplete = false;
          state.data.putLoading = false;
          state.data.putComplete = false;
          state.data.deleteLoading = false;
          state.data.deleteComplete = false;
          state.data.error = '';
      },
    },
    extraReducers: (builder) => {
        //getPatientBulletin
        builder.addCase(getBulletinsThunk.pending, (state) => {
          state.data.getLoading = true;
          state.data.getComplete = false;
          state.data.error = '';
        });
        builder.addCase(getBulletinsThunk.fulfilled, (state, action) => {
          state.data.getLoading = false;
          state.data.getComplete = true;
          state.data = Object.assign(state.data, action.payload);
        });
        builder.addCase(getBulletinsThunk.rejected, (state, action) => {
          state.data.getLoading = false;
          state.data.getComplete = false;
          state.data = Object.assign(state.data, action.payload);
          state.data.error = action.error ? action.error.message! : '';
        });
        
        // createPatientBulletin
        builder.addCase(createBulletinThunk.pending, (state) => {
            state.data.postLoading = true;
            state.data.postComplete = false;
            state.data.error = '';
          });
          builder.addCase(createBulletinThunk.fulfilled, (state, action) => {
            state.data.postLoading = false;
            state.data.postComplete = true;
            state.data = Object.assign(state.data, action.payload);
          });
          builder.addCase(createBulletinThunk.rejected, (state, action) => {
            state.data.postLoading = false;
            state.data.postComplete = false;
            state.data = Object.assign(state.data, action.payload);
            state.data.error = action.error ? action.error.message! : '';
          });

        // updatePatientBulletin
        builder.addCase(updateBulletinThunk.pending, (state) => {
          state.data.putLoading = true;
          state.data.putComplete = false;
          state.data.error = '';
        });
        builder.addCase(updateBulletinThunk.fulfilled, (state, action) => {
          state.data.putLoading = false;
          state.data.putComplete = true;
          state.data = Object.assign(state.data, action.payload);
        });
        builder.addCase(updateBulletinThunk.rejected, (state, action) => {
          state.data.putLoading = false;
          state.data.putComplete = false;
          state.data = Object.assign(state.data, action.payload);
          state.data.error = action.error ? action.error.message! : '';
        });

        builder.addCase(deleteBulletinThunk.pending, (state) => {
          state.data.deleteLoading = true;
          state.data.deleteComplete = false;
          state.data.error = '';
        });
        builder.addCase(deleteBulletinThunk.fulfilled, (state, action) => {
          state.data.deleteLoading = false;
          state.data.deleteComplete = true;
          state.data = Object.assign(state.data, action.payload);
        });
        builder.addCase(deleteBulletinThunk.rejected, (state, action) => {
          state.data.deleteLoading = false;
          state.data.deleteComplete = false;
          state.data = Object.assign(state.data, action.payload);
          state.data.error = action.error ? action.error.message! : '';
        });
    },
  });
  
  export const { patientBulletinSliceClean } = patientBulletinSlice.actions;
  export default patientBulletinSlice;